import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

export const ModalContractuales = ({
  data,
  show,
  hideModal,
  tamanio = "md",
  cerrable = true,
}) => {
  const { titulo, component } = data;

  return (
    <Modal centered show={show} size={tamanio} onHide={hideModal} backdrop="static" keyboard={cerrable}>
      <Modal.Header
        closeButton={cerrable}
        className="pb-2 pt-3"
        style={{
          backgroundColor: "#B0E6FF",
          borderRadius: "20px 20px 0 0",
          borderBottom: "1px solid #000",
        }}
      >
        <h5>{titulo}</h5>
      </Modal.Header>
      <Modal.Body className="pb-0">{component}</Modal.Body>
    </Modal>
  );
};

ModalContractuales.propTypes = {
  data: PropTypes.shape({
    titulo: PropTypes.string,
    component: PropTypes.node,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  tamanio: PropTypes.string,
  cerrable: PropTypes.bool,
};
